module.exports = __webpack_public_path__ + "img/xtdszn.06be5ae5.png";